export enum DentalParent{
    Active = 2,
    DeActive = 1
}